import {useCallback, useMemo} from 'react';
import {useFormikContext} from 'formik';
import {Drawer, DrawerFields} from 'components/customer/Product/entity/Drawer';
import {DrawerParameters} from 'components/customer/Product/entity/DrawerParameters';
import {
    cabinetDefault,
    followsCabinet,
} from 'components/customer/Product/Drawer/helpers';
import {useDrawerDefaults} from 'components/customer/Product/Drawer/DrawerDefaultsContext';

// whether a drawer keeps the cabinet's hardware; null while no default is
// known, since a drawer cannot override an unknown default
export const useFollowsCabinet = (drawerParams: DrawerParameters) => {
    const {values} = useFormikContext<DrawerFields>();
    const {defaults} = useDrawerDefaults();

    const cabinet = useMemo(() => {
        const drawers = values.drawers ?? [];

        return {
            type: cabinetDefault(
                drawers,
                drawerParams.drawerTypeFieldName,
                defaults.type
            ),
            runner: cabinetDefault(
                drawers,
                drawerParams.drawerRunnerFieldName,
                defaults.runner
            ),
        };
    }, [
        values.drawers,
        defaults,
        drawerParams.drawerTypeFieldName,
        drawerParams.drawerRunnerFieldName,
    ]);

    const hasDefault = cabinet.type !== '' || cabinet.runner !== '';

    return useCallback(
        (drawer: Drawer) =>
            hasDefault
                ? followsCabinet(
                      drawer,
                      cabinet,
                      drawerParams.drawerTypeFieldName,
                      drawerParams.drawerRunnerFieldName
                  )
                : null,
        [
            hasDefault,
            cabinet,
            drawerParams.drawerTypeFieldName,
            drawerParams.drawerRunnerFieldName,
        ]
    );
};
